import _get from 'lodash/get';
import _set from 'lodash/set';
import _isNil from 'lodash/isNil';

/**
 *
 * @desc DisplayAds utility
 *
 */
class DisplayAds {

    static init(displayAdConfig) {

        if(!this.canDisplayAds(displayAdConfig)) {

            return false;

        }

        this.setPageTargeting(displayAdConfig);

        window.mlbDoubleclick.init({
            adUnitHierarchy1: _get(displayAdConfig, 'adUnitHierarchy1'),
            adUnitHierarchy2: _get(displayAdConfig, 'adUnitHierarchy2'),
            responsive: _get(displayAdConfig, 'responsive'),
            thresholdsMap: _get(displayAdConfig, 'thresholdsMap'),
            thresholds: _get(displayAdConfig, 'thresholds'),
            enableVideoAds: _get(displayAdConfig, 'enableVideoAds', false),
            initAdElementIds: [],
            skipContainers: this.getVideoDisplayAdSlotIds(displayAdConfig),
        });

        return true;

    }

    static canDisplayAds(displayAdConfig) {

        if(_isNil(displayAdConfig)) {

            return false;

        }
        
        return (
            _get(displayAdConfig, 'enabled')
            && !_isNil(displayAdConfig.adUnitHierarchy1)
            && !_isNil(displayAdConfig.adUnitHierarchy2)
            && __CLIENT__
            && !_isNil(window.mlbDoubleclick)
            && !_isNil(window.mlbDoubleclick.init)
            && !_isNil(window.mlbDoubleclick.refresh)
            && !_isNil(window.mlbDoubleclick.destroySlots)
            && !_isNil(window.mlbDoubleclick.setPageTargeting)
        );

    }

    static updatePageTargeting(displayAdConfig) {

        const adPageTargeting = _get(displayAdConfig, 'pageTargeting');

        if(!this.canDisplayAds(displayAdConfig) || _isNil(adPageTargeting)) {

            return false;

        }

        this.setPageTargeting(displayAdConfig);
        this.refreshSlots(displayAdConfig);

        return true;

    }

    static setPageTargeting(displayAdConfig) {

        const adPageTargeting = _get(displayAdConfig, 'pageTargeting');
        
        if(!this.canDisplayAds(displayAdConfig) || _isNil(adPageTargeting)) {

            return false;

        }

        window.mlbDoubleclick.setPageTargeting(adPageTargeting);

        return true;

    }
    
    static refreshSlots(displayAdConfig) {

        if(!this.canDisplayAds(displayAdConfig)) {

            return false;

        }

        let adSlotIdsToRefresh = [];

        const displayAds = _get(displayAdConfig, 'displayAds', []);

        displayAds.forEach((displayAd) => {

            const adSlots = _get(displayAd, 'slots');
            
            adSlots.forEach((adSlot) => {

                const adSlotContentId = _get(adSlot, 'contentId');
    
                adSlotIdsToRefresh.push(`ad-${adSlotContentId}`);
    
            });

        });

        if (adSlotIdsToRefresh.length > 0) {

            window.mlbDoubleclick.refresh(adSlotIdsToRefresh);

        }

        return true;

    }

    static destroySlots(displayAdConfig) {

        if(!this.canDisplayAds(displayAdConfig)) {

            return false;

        }

        let adSlotIdsToDestroy = [];

        const displayAds = _get(displayAdConfig, 'displayAds', []);

        displayAds.forEach((displayAd) => {

            const adSlots = _get(displayAd, 'slots');
            
            adSlots.forEach((adSlot) => {

                const adSlotContentId = _get(adSlot, 'contentId');
    
                adSlotIdsToDestroy.push(`ad-${adSlotContentId}`);
    
            });

        });

        if (adSlotIdsToDestroy.length > 0) {

            window.mlbDoubleclick.destroySlots(adSlotIdsToDestroy);

        }

        return true;

    }

    static getVideoDisplayAdSlotIds(displayAdConfig) {

        if(!this.canDisplayAds(displayAdConfig)) {

            return {};

        }

        let videoAdSlotIds = {};

        const displayAds = _get(displayAdConfig, 'displayAds', []);

        displayAds.forEach((displayAd) => {

            const syncWithVideoAd = _get(displayAd, 'syncWithVideoAd');

            if(syncWithVideoAd) {

                const adSlots = _get(displayAd, 'slots');

                adSlots.forEach((adSlot) => {

                    const adSlotContentId = _get(adSlot, 'contentId');
        
                    videoAdSlotIds[`ad-${adSlotContentId}`] = true;
        
                });

            }

        });

        return videoAdSlotIds;

    }

    static lookupDisplayAd(displayAdConfig, adId) {

        if(_isNil(displayAdConfig) || _isNil(adId)) {

            return {};

        }

        const displayAds = _get(displayAdConfig, 'displayAds', []);
        
        return displayAds.find(({ id }) => id === adId) || {};

    }

    static updatePageTargetingPageIdWithTopicId(displayAdConfig, topicId) {

        const adPageTargetingPageIdTemplate = _get(displayAdConfig, 'pageTargetingPageIdTemplate');
        const canUpdatePageTargetPageId = !_isNil(displayAdConfig)  && !_isNil(adPageTargetingPageIdTemplate) && !_isNil(topicId);
        const pageTargeting = _get(displayAdConfig, 'pageTargeting', canUpdatePageTargetPageId ? {} : null);
        
        if(!canUpdatePageTargetPageId) {

            return pageTargeting;

        }

        _set(pageTargeting, 'pageid', adPageTargetingPageIdTemplate.replace('{topic_id}', topicId));

        return pageTargeting;

    }

};

export default DisplayAds;
